import { render, staticRenderFns } from "./FreePeriod.vue?vue&type=template&id=39d89805&scoped=true"
import script from "./FreePeriod.vue?vue&type=script&lang=ts"
export * from "./FreePeriod.vue?vue&type=script&lang=ts"
import style0 from "./FreePeriod.vue?vue&type=style&index=0&id=39d89805&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d89805",
  null
  
)

export default component.exports